<div class="text-center customer-container">
	<h2 class="customer-header">Customer Testimonials</h2>
	
	<swiper [config]="swiperConfig" class="mySwiper">
		<!-- PennyMac -->
		<ng-template swiperSlide>
			<div
				class="card"
				style="
					background: linear-gradient(
						90deg,
						#29abe2 0%,
						#0ec7be 100%
					);
				"
			>
				<p>
					RegScale bridges the divide between cybersecurity and
					compliance via it’s API-centric approach, integrating
					solutions to ensure you are continuously meeting your
					compliance obligations.
				</p>
				<div class="slide-bottom">Karl Mattson, CISO</div>
			</div>
		</ng-template>
		<!-- TDOT  -->
		<ng-template swiperSlide>
			<div
				class="card"
				style="
					background: linear-gradient(
						90deg,
						#f3931f 0%,
						#ef5a23 50%,
						#9e0e5d 100%
					);
				"
			>
				<p>
					RegScale has proven to be invaluable as a FISMA reporting
					tool as well as documenting other Cyber Security programs.
					TDOT continues to perform strategic control assessments,
					risk assessments, disaster recovery, and cyber security
					auditing with the platform which makes it simple to prepare
					reports and policies for our organization. Now that our
					organization has a single location to prepare reports,
					submitting our compliances has become an easy task that is
					saving our organization time and money.
				</p>
				<div class="slide-bottom">
					Dr. Richard White, Tennessee Department of Transportation
					(TDOT)
				</div>
			</div>
		</ng-template>
		<!-- CSA -->
		<ng-template swiperSlide>
			<div
				class="card"
				style="
					background: linear-gradient(
						90deg,
						#29abe2 0%,
						#0ec7be 100%
					);
				"
			>
				<p>
					Cyber Security and Compliance are top of mind for heavily regulated organizations. Purpose-built solutions that can help organizations proactively manage compliance with applicable laws and regulations are critically needed, and we applaud RegScale for bridging the divide between security and compliance via automation. 
				</p>
				<div class="slide-bottom">Jim Reavis, CEO, Cloud Security Alliance (CSA)</div>
			</div>
		</ng-template>
		<!-- JCF  -->
		<ng-template swiperSlide>
			<div
				class="card"
				style="
					background: linear-gradient(
						90deg,
						#f3931f 0%,
						#ef5a23 50%,
						#9e0e5d 100%
					);
				"
			>
				<p>
					In a short period of time, RegScale has brought us value allowing us to move our compliance processes into a digital system of record. As an early co-innovator, we saw the value RegScale delivered to ensure we were consistently meeting compliance requirements and they are quickly adding additional capabilities to give us complete insight into our overall compliance obligations in real-time.
				</p>
				<div class="slide-bottom">
					Tom Gerdes, Vice President (VP) of IT for Johnson Controls Federal Systems (JCFS)
				</div>
			</div>
		</ng-template>
	</swiper>
</div>
